import { Post } from './api';

interface Props {
  post: Post;
  onEdit: () => void;
  onDelete: () => void;
}

function formatDate(iso: string): string {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export default function PostCard({ post, onEdit, onDelete }: Props) {
  return (
    <article className="flex flex-col overflow-hidden rounded-2xl bg-white shadow-card transition-transform duration-200 hover:-translate-y-0.5">
      {post.featured_image_url ? (
        <img src={post.featured_image_url} alt="" className="h-[188px] w-full object-cover" />
      ) : (
        <div
          className="flex h-[188px] w-full items-end bg-gradient-to-br from-[#dde7bc] to-[#cdd9a6] p-3.5
                     font-mono text-[10.5px] tracking-[0.08em] text-[#506028]/55"
          aria-hidden="true"
        >
          no featured image
        </div>
      )}

      <div className="flex flex-1 flex-col gap-3 p-5">
        <div className="flex items-center gap-3">
          <span
            className={
              'rounded-full px-2.5 py-1 text-[11.5px] font-trirong_reg leading-none ' +
              (post.published ? 'bg-badgepub-bg text-badgepub-fg' : 'bg-badgedraft-bg text-badgedraft-fg')
            }
          >
            {post.published ? 'Published' : 'Draft'}
          </span>
          <span className="font-trirong_light text-[13px] text-meta">{formatDate(post.updated_at)}</span>
        </div>

        <h3 className="font-trirong_reg text-[21px] leading-snug text-lime-700">{post.title || 'Untitled'}</h3>
        {post.excerpt && (
          <p className="line-clamp-2 font-trirong_light text-sm leading-relaxed text-gray-600">{post.excerpt}</p>
        )}

        <div className="mt-1 flex items-center gap-4">
          <button
            type="button"
            onClick={onEdit}
            className="rounded-full border border-field px-4 py-1.5 text-sm font-trirong_reg text-lime-700
                       transition-colors hover:border-lime-700 hover:bg-[#fbfdf4] focus:outline-none
                       focus:ring-2 focus:ring-lime-600/40"
          >
            Edit
          </button>
          <button
            type="button"
            onClick={onDelete}
            className="font-trirong_reg text-[15px] text-danger transition-colors hover:text-danger-deep
                       hover:underline hover:underline-offset-2 focus:outline-none"
          >
            Delete
          </button>
        </div>
      </div>
    </article>
  );
}
